import type { Editor } from "@tiptap/core"
import type { Node as ProseMirrorNode } from "@tiptap/pm/model"

/**
 * Пробелы-отбивки для вставки продиктованного текста в диапазон [from, to].
 * Вынесено из insertDictatedText отдельно, чтобы покрыть юнит-тестом без DOM.
 *
 * "\0" за листовые ноды: чип меншена должен считаться непробельным соседом, иначе текст
 * приклеится к токену. То же соглашение, что в mention-insert-space.ts.
 */
export function dictationSpacing(doc: ProseMirrorNode, from: number, to: number): { lead: string; trail: string } {
  const before = doc.textBetween(Math.max(0, from - 1), from, "\n", "\0")
  const after = doc.textBetween(to, Math.min(doc.content.size, to + 1), "\n", "\0")
  return {
    lead: before !== "" && !/\s/.test(before) ? " " : "",
    trail: after !== "" && !/\s/.test(after) ? " " : "",
  }
}

/**
 * Вставляет продиктованный текст в позицию каретки, отбивая его пробелами от соседей
 * с обеих сторон. Общий для композера агента и полей промпта генерации.
 */
export function insertDictatedText(editor: Editor, text: string): void {
  const chunk = text.trim()
  if (chunk === "") return

  // Поле могли ни разу не трогать — тогда каретка Tiptap стоит в самом начале
  // (Selection.atStart), и диктовка уехала бы ПЕРЕД уже набранным промптом.
  // Ожидаемое место в этом случае — конец.
  if (!editor.isFocused) editor.commands.focus("end")

  const { doc, selection } = editor.state
  const { lead, trail } = dictationSpacing(doc, selection.from, selection.to)

  editor.chain().focus().insertContent(`${lead}${chunk}${trail}`).run()
}
